import { CommonContentWrapper } from "../../common/components/content_wrapper/CommonContentWrapper";
import { Container, Padding, Row, SizedBox } from "../../common/components/CommonBaseComponents";
import { PageTitle } from "../../common/components/PageTitle";
import { GoogleMap, useLoadScript } from "@react-google-maps/api";
import React, { useState } from "react";
import MapMarkerLabel from "./components/MapMarkerLabel";
import { GoogleMapGlobalStyle } from "./components/GoogleMapStyles";
import Translate from "../../common/translate/Translate";
import { useDevice } from "../../common/hooks/useDevice";
import StoreService from "../../service/StoreService";

const center = { lat: 13.7563, lng: 100.5018 };

// zoom level → 가시 반경(km) 변환: zoom 10 ≈ 20km, zoom 12 ≈ 5km, zoom 14 ≈ 1km
const getRadiusFromZoom = (zoom) => Math.min(100, Math.max(1, Math.round(40075 / Math.pow(2, zoom + 1)) * 10));

const mapOptions = {
    disableDefaultUI: true,
    clickableIcons: false,
    gestureHandling: "greedy",
    styles: [
        {
            //지도에서 장소 아이콘 제거
            featureType: "poi",
            stylers: [{ visibility: "off" }],
        },
    ],
};

export function StoreMapPage() {
    const { isLoaded } = useLoadScript({
        googleMapsApiKey: process.env.REACT_APP_GOOGLE_MAP_API_KEY,
    });

    const service = new StoreService();

    const [stores, setStores] = useState([]);

    const fetchStoreList = (radius, userLatitude, userLongitude) => {
        console.log(radius, userLatitude, userLongitude);
        service.getGpsStoreList({ radius, userLatitude, userLongitude }).then((res) => {
            const stores = (res?.storeInfo ?? [])
                .filter((item) => Array.isArray(item.longitude) && item.longitude.length >= 2)
                .map((item) => {
                    item.position = { lat: Number(item.longitude[0]), lng: Number(item.longitude[1]) };
                    return item;
                });
            console.log(stores);
            setStores(stores);
        });
    };

    // 추후 지도 클릭 이벤트 등을 처리해야 할 경우, map 객체 사용
    const [map, setMap] = useState(null);

    const currentDevice = useDevice();
    if (!isLoaded) return null;
    return (
        <CommonContentWrapper>
            <Padding padding={"24px 20px"}>
                <PageTitle title={Translate("gnb.storeMap")} />
            </Padding>
            <SizedBox height={"4px"} />
            {/* 구글 저작권 + 로고 + 단축키 + 약관 제거 */}
            <GoogleMapGlobalStyle />
            <Container
                style={{
                    padding: currentDevice === "mobile" || currentDevice === "tablet" ? "0" : "0 20px 0px 20px",
                    display: "flex",
                }}
            >
                <GoogleMap
                    center={center}
                    zoom={10}
                    onLoad={(m) => {
                        setMap(m);
                        const mapCenter = m.getCenter();
                        fetchStoreList(100, mapCenter.lat(), mapCenter.lng());
                    }}
                    onDragEnd={() => {
                        if (!map) return;
                        const mapCenter = map.getCenter();
                        const radius = getRadiusFromZoom(map.getZoom());
                        fetchStoreList(radius, mapCenter.lat(), mapCenter.lng());
                    }}
                    onZoomChanged={() => {
                        if (!map) return;
                        const mapCenter = map.getCenter();
                        const radius = getRadiusFromZoom(map.getZoom());
                        fetchStoreList(radius, mapCenter.lat(), mapCenter.lng());
                    }}
                    mapContainerStyle={{
                        width: currentDevice === "mobile" || currentDevice === "tablet" ? "100vw" : "80vw",
                        height: "80vh",
                        borderRadius: "16px",
                        overflow: "hidden",
                    }}
                    options={mapOptions}
                >
                    {stores.map((store) => (
                        <MapMarkerLabel
                            key={store.id}
                            position={store.position}
                            shopCode={store.storeId}
                            name={store.storeName}
                            washers={store.washers}
                            dryers={store.dryers}
                            combos={store.combos}
                            phone={store.phone}
                            images={store.images}
                        />
                    ))}
                </GoogleMap>
            </Container>

            <Row></Row>
        </CommonContentWrapper>
    );
}
